import { InternalAmenityGroupEnum } from '@app/models/api/api-types';
import { AmenityGroupModel } from '@app/models/elastic-search';

const AMENITY_DISPLAY_ORDER = [
    InternalAmenityGroupEnum.Parking,
    InternalAmenityGroupEnum.SwimmingPool,
    InternalAmenityGroupEnum.Jacuzzi,
    InternalAmenityGroupEnum.Sauna,
    InternalAmenityGroupEnum.ChildrensArea,
    InternalAmenityGroupEnum.PetFriendly,
    InternalAmenityGroupEnum.Wifi,
];

/**
 * Sorts amenities according to the specified display order:
 * parking, pool, jacuzzi, sauna, playground, pets, wifi, then rest
 */
export const sortAmenities = (amenities: AmenityGroupModel[]): AmenityGroupModel[] => {
    return [...amenities].sort((a, b) => {
        const indexA = AMENITY_DISPLAY_ORDER.indexOf(a.type);
        const indexB = AMENITY_DISPLAY_ORDER.indexOf(b.type);

        if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
        }

        if (indexA !== -1) {
            return -1;
        }

        if (indexB !== -1) {
            return 1;
        }

        return 0;
    });
};
